import { makeStyles } from '@material-ui/core/styles';
import { getDomain } from '../../utils/config';

export const useStyles = makeStyles(theme => ({
	breadcrumbs: {
		gap: theme.spacing(1),
		'& .MuiBreadcrumbs-separator': {
			marginTop: getDomain() === 'onsemi.com' ? theme.spacing(1.5) : theme.spacing(2.3)
		},
		'& .MuiTypography-root': {
			marginBottom: theme.spacing(2.5),
			textDecoration: 'none',
			fontWeight: 700,
			color: 'rgba(100, 102, 105, 1)'
		}
	},
	homeIcon: {
		paddingBottom: 1
	}
}));
